import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { shadows } from './shadows';
import { typography } from './typography';
import { overrides } from './overrides';
import { customShadows } from './custom-shadows';

declare module '@mui/material/styles' {
  interface Theme {
    customShadows: typeof customShadow;
  }
  interface ThemeOptions {
    customShadows?: typeof customShadow;
  }
}

const paletted: any = palette();
const shadow: any = shadows();
const customShadow: any = customShadows();
const typographies: any = typography;

const theme: any = createTheme({
  palette: paletted,
  shadows: shadow,
  typography: typographies,
  customShadows: customShadow,
  shape: { borderRadius: 8 },
});

theme.components = overrides(theme);

export default theme;
